import InvestStrategyPage from './InvestStrategyPage';

export default InvestStrategyPage;
